import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import sha256 from 'crypto-js/sha256';
import { DatePicker } from 'antd';
import imageNotFound from '../images/no-image-icon-6.png'

function PointageDisplay() {


    const { t } = useTranslation();

    const apiUrl = process.env.REACT_APP_BACKEND_URL
    const ImageUrl = process.env.REACT_APP_IMAGES_URL
    const frontEndUrl = process.env.REACT_APP_REACT_URL

    let userId = Cookies.get('userId');
    let UserToken = Cookies.get('UserSpecialToken');
    let IdEntreprise = Cookies.get('IdEntreprise');
    let LanguageSelected = Cookies.get('LanguageSelected');

    const [PointageContent, setPointageContent] = useState([])
    const hashedUserId = sha256((String(userId)));
    const [PointageModal, setPointageModal] = useState(false)
    const [isFetching, setisFetching] = useState(false)

    const [Done, setDone] = useState(false)
    const [PointageDetails, setPointageDetails] = useState(false)
    const [SelectedPointage, setSelectedPointage] = useState({})
    const [PointageId, setPointageId] = useState(null)

    const [FilterData, setFilterData] = useState({})


    useEffect(() => {
        getUserPointageHistory()
    }, [Done, PointageModal])

    const handleDateRageData = (dates, dateStrings) => {
        getUserPointageHistory(dateStrings[0], dateStrings[1])
    }

    const { RangePicker } = DatePicker;



    const getUserPointageHistory = (start = null, end = null) => {
        fetch(`${apiUrl}/getUserPointageHistory`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ user_id: userId, start, end })
        })
            .then(response => response.json())
            .then(result => {
                setPointageContent(result.data)
                console.log('data-----------', result.data)
            })


    }

    const deletePointage = async (id) => {
        setisFetching(true)
        fetch(`${apiUrl}/deletePointage`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json", 'Authorization': `Bearer ${UserToken}`
            },
            body: JSON.stringify({ pointage_id: id })
        })
            .then(response => response.json())
            .then(result => {
                if (result.success) {
                    setDone(!Done)
                    setPointageDetails(false)
                    setPointageId(null)
                    setisFetching(false)

                    toast.success(result.message, {
                        position: toast.POSITION.CENTER
                    });
                }
            })
        setisFetching(false)

    }


    function formatDate(dateString) {
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    }

    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
    });

    const handleSelect = (ranges) => {
        console.log(ranges);
        // Handle the selected range
    };

    return (
        <div className='w-full'>
            <button onClick={() => setPointageModal(true)} type="submit" className="w-full font-semibold relative text-theme flex justify-start items-center mt-3 p-3 py-2 px-4 border border-transparent rounded shadow-sm text-sm font-medium text-black sections h-16  hover:bg-gold focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-5 ml-3' : 'w-6 mr-5'}`}>
                    <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>


                {t("Pointage History")}

            </button>

            {PointageModal &&
                <div>
                    <div className="minscreen h-full overflow-y-auto animated fadeIn faster  fixed  left-0 top-0 flex justify-center items-start inset-0 z-50 forms-info ">
                        <div className="absolute top-0 right-0 p-4">
                            <a className='w-12 h-12' onClick={() => { setPointageModal(false) }} >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-theme cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                </svg>
                            </a>
                        </div>
                        <div className="w-full h-2/3 settingswidth grid  place-items-start p-8 ">
                            <div className="flex h-full items-center justify-start ">
                                <p className="text-2xl text-gold mb-5 mt-5 font-bold">{t("Pointage History")}</p>
                            </div>

                            <div className='w-full pb-12  space-y-3'>
                                <div className='datePicker'>
                                    <RangePicker className='h-14 w-full sections text-theme  placeholder-gray-111 border-none' onChange={handleDateRageData} />

                                </div>
                                {
                                    PointageContent.length > 0 ? (
                                        PointageContent.map((pointage, index) => (
                                            <a onClick={() => { setPointageDetails(true); setSelectedPointage(pointage) }} key={index} className={`relative w-full flex sections items-center  py-4 px-4 border border-transparent rounded shadow-sm text-sm font-medium font-semibold text-theme  h-16 hover:bg-gold focus:outline-none gap-3 focus:ring-2 focus:ring-offset-2 focus:ring-gold`} >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className={`lucide lucide-file-clock w-8 h-8`}><path d="M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3" /><path d="M14 2v4a2 2 0 0 0 2 2h4" /><circle cx="8" cy="16" r="6" /><path d="M9.5 17.5 8 16.25V14" /></svg>
                                                <div className='flex justify-between items-center w-full'>
                                                    <div className='grid'>
                                                        <p className='text-theme text-sm '>{formatDate(pointage.date)} - {formatDate(pointage.exit_date)}</p>

                                                    </div>
                                                    <div className='flex justify-end items-center gap-1'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" className={`lucide lucide-chevron-right w-6 h-6`} ><path d="m9 18 6-6-6-6" /></svg>

                                                    </div>
                                                </div>


                                            </a>
                                        ))
                                    ) : (
                                        <div>
                                            <h2 className="text-2xl text-about mb-6">{t("Il n'y a aucun pointage.")}</h2>
                                        </div>
                                    )
                                }

                            </div>

                        </div>
                    </div>
                </div>
            }

            {PointageDetails &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative h-fit overflow-y-auto findservice  -mt-10 rounded-xl   sections">


                        <div className=' grid gap-3' >
                            <div className="flex items-center text-2xl text-gold   font-bold justify-start px-3">
                                {t("Pointage Details")}
                            </div>
                            <div className='overflow-y-auto p-3 -mt-1 grid gap-3' style={{ height: '70vh' }}>
                                <div className='div-sections rounded-xl w-full h-fit p-3 grid gap-3'>
                                    <p className="text-2xl text-gold mx-3 font-bold">{t("Entry")}</p>

                                    <div class="w-full h-fit flex justify-center items-center rounded-xl">
                                        {
                                            SelectedPointage.image ?
                                                <img src={SelectedPointage.image} className='w-full h-full rounded-xl object-fit' />

                                                :
                                                <img src={imageNotFound} className='w-40 h-40 rounded-xl object-fit' />

                                        }

                                    </div>
                                    <div className='flex sections rounded-xl justify-start items-center gap-3 p-3'>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide text-theme w-6 h-6  lucide-map-pinned"><path d="M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0" /><circle cx="12" cy="8" r="2" /><path d="M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835" /></svg>
                                        </div>                                        <p className='text-theme text-sm '>{SelectedPointage.location}</p>

                                    </div>
                                    <div className='flex sections rounded-xl justify-start items-center gap-3 p-3'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide text-theme w-6 h-6 lucide-calendar-clock"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h5" /><path d="M17.5 17.5 16 16.3V14" /><circle cx="16" cy="16" r="6" /></svg>
                                        <p className='text-theme text-sm '>{formatDate(SelectedPointage.date)} </p>

                                    </div>

                                    {SelectedPointage.comment &&
                                        <div className='flex sections rounded-xl justify-start items-start gap-3 p-3'>
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide text-theme w-6 h-6  lucide-message-circle"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" /></svg>
                                            </div>
                                            <p className='text-theme text-sm '>{SelectedPointage.comment} </p>

                                        </div>
                                    }
                                </div>

                                <div className='div-sections rounded-xl w-full h-fit p-3 grid gap-3'>
                                    <p className="text-2xl text-gold mx-3 font-bold">{t("Exit")}</p>

                                    <div class="w-full h-fit flex justify-center items-center rounded-xl">
     {
                                            SelectedPointage.exit_image ?
                                                <img src={SelectedPointage.exit_image} className='w-full h-full rounded-xl object-fit' />

                                                :
                                                <img src={imageNotFound} className='w-40 h-40 rounded-xl object-fit' />

                                        }
                                    </div>
                                    <div className='flex sections rounded-xl justify-start items-center gap-3 p-3'>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide text-theme w-6 h-6  lucide-map-pinned"><path d="M18 8c0 4.5-6 9-6 9s-6-4.5-6-9a6 6 0 0 1 12 0" /><circle cx="12" cy="8" r="2" /><path d="M8.835 14H5a1 1 0 0 0-.9.7l-2 6c-.1.1-.1.2-.1.3 0 .6.4 1 1 1h18c.6 0 1-.4 1-1 0-.1 0-.2-.1-.3l-2-6a1 1 0 0 0-.9-.7h-3.835" /></svg>
                                        </div>
                                        <p className='text-theme text-sm '>{SelectedPointage.exit_location}</p>

                                    </div>
                                    <div className='flex sections rounded-xl justify-start items-center gap-3 p-3'>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide text-theme w-6 h-6 lucide-calendar-clock"><path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" /><path d="M16 2v4" /><path d="M8 2v4" /><path d="M3 10h5" /><path d="M17.5 17.5 16 16.3V14" /><circle cx="16" cy="16" r="6" /></svg>
                                        <p className='text-theme text-sm '>{formatDate(SelectedPointage.exit_date)} </p>

                                    </div>

                                    {SelectedPointage.exit_comment &&
                                        <div className='flex sections rounded-xl justify-start items-start gap-3 p-3'>
                                            <div>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide text-theme w-6 h-6  lucide-message-circle"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" /></svg>
                                            </div>
                                            <p className='text-theme text-sm '>{SelectedPointage.exit_comment} </p>

                                        </div>
                                    }


                                </div>


                            </div>


                            <div className="grid place-items-center grid-cols-2 gap-3 w-full px-3">
                                <button onClick={(e) => setPointageDetails(false)} type="submit" className="m-3 hover:scale-1.1  mr-3 w-full btn-edit">


                                    {t("close")}
                                </button>
                                <button onClick={(e) => setPointageId(SelectedPointage.id)} type="submit" className="m-3  mr-3 w-full btn-edit">


                                    {t("delete")}
                                </button>
                            </div>



                        </div>



                    </div>
                </div>
            }
            {PointageId &&
                <div className="fixed z-50 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10">
                    <div className="relative h-fit overflow-y-auto findservice  -mt-10 rounded-xl   sections">
                        <div className='px-3 ' >
                            <div className="flex  items-center justify-center ">
                                <p className="text-xl text-theme text-center m-3 font-normal">{t("are you sure you want to delete this Pointage!")} </p>
                            </div>


                            <div className="grid place-items-center grid-cols-2 gap-3 w-full px-3">
                                <button onClick={(e) => setPointageId(null)} type="submit" className="m-3 hover:scale-1.1  mr-3 w-full btn-edit">


                                    {t("annuler")}
                                </button>
                                <button onClick={(e) => deletePointage(PointageId)} disabled={isFetching} type="submit" className="m-3  mr-3 w-full btn-edit">
                                    {isFetching ?
                                        (<svg class="w-4 h-4 text-gray-300 animate-spin" viewBox="0 0 64 64" fill="none"
                                            xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                                            <path
                                                d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path
                                                d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                                stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" class="text-gray-900">
                                            </path>
                                        </svg>)
                                        : (
                                            t('valide')
                                        )
                                    }

                                </button>
                            </div>



                        </div>



                    </div>
                </div>
            }


        </div>


    )
}

export default PointageDisplay